import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

import {
  computed,
} from 'vue';
import { getBaseButtonCSSMargin } from '@/utils/BaseCSSHelper.js';
import IoRouterLink from '@/components/IoRouterLink.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  title: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: 'primary',
  },
  textAlign: {
    type: String,
    default: 'center',
  },
  align: {
    type: String,
    default: 'center',
  },
  type: {
    type: String,
    default: 'default',
  },
  typeHover: {
    type: String,
    default: 'inherit',
  },
  colorHover: {
    type: String,
    default: 'inherit',
  },
  width: {
    type: String,
    default: 'auto',
  },
  rounded: {
    type: String,
    default: '0',
  },
  roundedHover: {
    type: String,
    default: 'inherit',
  },
  linkType: {
    type: String,
    default: 'page',
  },
  pageUrl: String,
  pageId: String,
  mediaId: {
    type: String,
    default: '0',
  },
  mediaUrl: {
    type: String,
    default: '0',
  },
  mediaAlt: {
    type: String,
    default: '',
  },
  url: String,
  anchor: String,
  small: {
    type: String,
    default: '0',
  },
  large: {
    type: String,
    default: '0',
  },
  icon: {
    type: String,
    default: null,
  },
  buttonType: {
    type: String,
    default: undefined,
    requried: false,
  },
},
  setup(__props) {

const props = __props;

const classes = computed(() => {
  const btnClasses = [];

  if (props.type === 'outline') {
    btnClasses.push(`btn-outline-${props.color}`);
  } else {
    btnClasses.push(`btn-${props.color}`);
  }

  if (props.typeHover !== 'inherit') {
    if (props.typeHover === 'outline') {
      btnClasses.push(`btn-hover-outline-${props.colorHover === 'inherit' ? props.color : props.colorHover}`);
    } else {
      btnClasses.push(`btn-hover-${props.colorHover === 'inherit' ? props.color : props.colorHover}`);
    }
  } else if (props.colorHover !== 'inherit') {
    if (props.type === 'outline') {
      btnClasses.push(`btn-hover-outline-${props.colorHover}`);
    } else {
      btnClasses.push(`btn-hover-${props.colorHover}`);
    }
  }

  if (props.small === '1') {
    btnClasses.push('btn-sm');
  }

  if (props.large === '1') {
    btnClasses.push('btn-lg');
  }

  if (props.rounded === '1') {
    btnClasses.push('btn-rounded');
  }

  if (props.roundedHover !== 'inherit') {
    btnClasses.push(`btn-hover-${props.roundedHover === '1' ? 'rounded' : 'squared'}`);
  }

  if (props.width === 'full') {
    btnClasses.push('w-100');
  }

  btnClasses.push(`text-${props.textAlign}`);

  if (props.icon !== null) {
    btnClasses.push('btn--icon');
  }

  return btnClasses;
});

const style = computed(() => {
  const styles = {} as Record<string, string>;

  if (props.width !== 'full') {
    styles['--base-button-margin'] = getBaseButtonCSSMargin(props.align);
  }

  return styles;
});

const isEmail = (email: string) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const buttonUrl = computed<string>(() => {
  let url;

  switch (props.linkType) {
    case 'page':
      url = props.pageUrl;
      break;
    case 'document':
      url = props.mediaUrl;
      break;
    case 'url':
      if (props.url && isEmail(props.url) && props.url.indexOf('mailto:') !== 0) {
        url = `mailto:${props.url}`;
      }
      url = props.url;
      break;
    default:
      url = null;
  }

  url = `${url || ''}`.trim();

  const anchor = `${props.anchor || ''}`.trim();

  if (
    props.linkType !== 'document'
      && anchor.length
  ) {
    url = `${url}#${anchor}`;
  }

  return url;
});

const buttonTarget = computed<string>(() => {
  switch (props.linkType) {
    case 'document':
    case 'url':
      if (props.url?.indexOf('javascript') === 0) {
        return '_self';
      }
      return '_blank';

    default:
      return '_self';
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.linkType !== 'button')
    ? (_openBlock(), _createBlock(IoRouterLink, {
        key: 0,
        "link-url": buttonUrl.value,
        class: _normalizeClass(["base-button btn", classes.value]),
        "link-target": buttonTarget.value,
        style: _normalizeStyle(style.value)
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: _normalizeClass(__props.icon)
          }, null, 2),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["link-url", "class", "link-target", "style"]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(["base-button btn", classes.value]),
        type: __props.buttonType,
        style: _normalizeStyle(style.value)
      }, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(__props.icon)
            }, null, 2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 14, _hoisted_1))
}
}

})